(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lefty-census"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lefty-census]').forEach((root) => {
  if (root.dataset.censusInit) return;
  root.dataset.censusInit = '1';
  const choices = root.querySelector('[data-census-choices]');
  const results = root.querySelector('[data-census-results]');
  const verdict = root.querySelector('[data-census-verdict]');
  const verdicts = {
    left: 'NOTED IN THE REGISTRY. AS PREDICTED.',
    right: 'NOTED. THE MINORITY REPORT GROWS.',
    balanced: 'NOTED AS "BALANCED (ALLEGEDLY)". UNDER OBSERVATION.'
  };
  choices.querySelectorAll('[data-census-vote]').forEach((btn) => {
    btn.addEventListener('click', () => {
      choices.hidden = true;
      results.hidden = false;
      verdict.textContent = verdicts[btn.dataset.censusVote] || 'NOTED.';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lefty-intake-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lefty-intake]').forEach((root) => {
  if (root.dataset.intakeInit) return;
  root.dataset.intakeInit = '1';
  const checks = root.querySelectorAll('[data-intake-check]');
  const diagnosis = root.querySelector('[data-intake-diagnosis]');
  const idle = diagnosis.textContent;
  const lines = [
    idle,
    'DIAGNOSIS: EARLY-STAGE AWARENESS. TREATABLE.',
    'DIAGNOSIS: CHRONIC ADJUSTER. TREATMENT STRONGLY INDICATED.',
    'DIAGNOSIS: TEXTBOOK CASE. TREATMENT SHIPS IN 2\u20134 BUSINESS DAYS.'
  ];
  const update = () => {
    const n = [...checks].filter((c) => c.checked).length;
    diagnosis.textContent = lines[Math.min(n, lines.length - 1)];
  };
  checks.forEach((c) => c.addEventListener('change', update));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lefty-preorder-progress"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-lefty-poprog]').forEach((root) => {
  if (root.dataset.poprogInit) return;
  root.dataset.poprogInit = '1';
  const reveal = () => root.classList.add('lefty-poprog--animate');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { reveal(); io.disconnect(); } });
    }, { threshold: 0.35 });
    io.observe(root);
  } else { reveal(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
